// extracted by mini-css-extract-plugin
export default {"button":"SeasonRoundDetailsButton_button__IGq+0"};